import * as React from "react";

export const FailureIcon: React.FC<React.SVGProps<SVGElement>> = ({
  color = "currentColor",
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    fill="none"
    viewBox="0 0 14 14"
  >
    <g clipPath="url(#a)">
      <path
        fill={color}
        fillRule="evenodd"
        d="M10.49 4.37a.878.878 0 0 0-1.497-.621L6.99 5.76 4.986 3.758a.85.85 0 0 0-.621-.263.878.878 0 0 0-.622 1.496l2.004 2.004L3.744 9a.878.878 0 0 0 1.242 1.243L6.99 8.237l2.003 2.003a.877.877 0 0 0 1.243-1.243L8.232 6.996l2.004-2.004a.87.87 0 0 0 .254-.62M6.99-.005c-3.868 0-7 3.133-7 7s3.132 7 7 7 7-3.132 7-7-3.133-7-7-7"
        clipRule="evenodd"
      ></path>
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h14v14H0z"></path>
      </clipPath>
    </defs>
  </svg>
);
